import React from "react";
import { Home } from "react-feather";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";

const Breadcrumb = ({ title, parent }) => {
  const { t } = useTranslation();

  return (
    <Container fluid={true}>
      <div className="page-header">
        <Row>
          <Col lg="6">
            <div className="page-header-left">
              <h3>
                {t(title, title)}
                <small>{t("WEGE Admin panel", "WEGE Admin panel")}</small>
              </h3>
            </div>
          </Col>
          <Col lg="6">
            <ol className="breadcrumb pull-right">
              <li className="breadcrumb-item">
                <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                  <Home />
                </Link>
              </li>
              {parent && <li className="breadcrumb-item">{t(parent, parent)}</li>}
              <li className="breadcrumb-item active">{t(title, title)}</li>
            </ol>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default Breadcrumb;
